// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"52ce8c20","256":"7ec3f430","646":"3509b6a7","961":"be69c07c"}[chunkId] + ".chunk.css";
};